export { currentUserAgent, detectBrowserEngine } from "./browserDetection";
export { FIREFOX_STORE_REVIEW_PENDING, FIREFOX_STORE_URL, resolveHelperInstallRoute, resolveInstallStoreLabel, resolveInstallStoreUrl, } from "./browserExtensionStores";
export { CHROME_EXTENSION_ID, CHROME_EXTENSION_ID_DEV, CHROME_STORE_URL, resolveChromeExtensionId, } from "./chromeExtension";
export { MAILBOX_WEB_URL } from "./mailboxWebUrls";
// Empty string = same-origin. Firebase Hosting rewrites /v1/** and /api/**
// to the Cloud Run proxy service, so the client does not need an absolute
// host — it relies on the page origin.
const DEFAULT_CONFIG = {
    baseUrl: "",
};
export function getApiConfig() {
    // Build-time config (recommended): Vite `define` can inject this constant.
    // Example:
    // define: { __V2M_API_BASE_URL__: JSON.stringify("https://...") }
    const definedBaseUrl = typeof __V2M_API_BASE_URL__ === "string" && __V2M_API_BASE_URL__.length > 0
        ? __V2M_API_BASE_URL__
        : undefined;
    if (definedBaseUrl) {
        return { baseUrl: definedBaseUrl };
    }
    // Check for global configuration (for runtime configuration)
    if (typeof window !== "undefined" && window.VOICE2MAIL_CONFIG?.baseUrl) {
        return { baseUrl: window.VOICE2MAIL_CONFIG.baseUrl };
    }
    return DEFAULT_CONFIG;
}
